import InputLabel from "@mui/material/InputLabel";
import { format } from "date-fns";
import { useField } from "formik";
import { Translate } from "@/components/Application/Translate";
import { useTheme } from "@mui/material/styles";

interface Props
	extends React.DetailedHTMLProps<
		React.InputHTMLAttributes<HTMLInputElement>,
		HTMLInputElement
	> {
	label: string;
	name: string;
	type: string;
	id: string;
	value?: string;
	rows?: number;
	placeholder?: string;
	translationString?: string;
}

const CustomInput = ({ label, id, translationString, ...props }: Props) => {
	const [field, meta] = useField(props);
	const theme = useTheme();

	if (props.type === "date") {
		field.value = format(new Date(field.value), "yyyy-MM-dd");
	}

	const hasError = meta.touched && meta.error;
	return (
		<div className="input-container">
			<InputLabel htmlFor={id}>
				<Translate String={translationString || ""}>{label}</Translate>
			</InputLabel>
			<input
				id={id}
				{...field}
				{...props}
				className={hasError ? "input-error borderisgrey" : "borderisgrey"}
				style={{
					backgroundColor: theme.palette.mode === "dark" ? "#333" : "#fff",
					color: theme.palette.mode === "dark" ? "#fff" : "#000",
					borderColor: hasError ? "red" : theme.palette.mode === "dark" ? "#555" : "#ccc",
				}}
			/>
			{hasError && <div className="error">{meta.error}</div>}
		</div>
	);
};

export default CustomInput;
